import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProductsState } from './productModels';
import { getAllProducts, getProductDetails, getProductsByModel } from './productThunks';

const initialState: ProductsState = {
  productsCategory: [],
  currentProduct: null,
  relatedProducts: [],
  modelProducts: [],
  loading: false,
  error: null,
  status: 'idle',
};

const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: {
    clearProductDetails: (state) => {
      state.currentProduct = null;
      state.relatedProducts = [];
    },
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get all products
      .addCase(getAllProducts.pending, (state) => {
        state.loading = true;
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getAllProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'succeeded';
        state.productsCategory = action.payload.productsCategory;
      })
      .addCase(getAllProducts.rejected, (state, action) => {
        state.loading = false;
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch products';
      })
      // Get product details
      .addCase(getProductDetails.pending, (state) => {
        state.loading = true;
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getProductDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'succeeded';
        state.currentProduct = action.payload.product;
        state.relatedProducts = action.payload.relatedProducts;
      })
      .addCase(getProductDetails.rejected, (state, action) => {
        state.loading = false;
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch product details';
      })
      // Get products by model
      .addCase(getProductsByModel.pending, (state) => {
        state.loading = true;
        state.status = 'loading';
        state.error = null;
      })
      .addCase(getProductsByModel.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'succeeded';
        state.modelProducts = action.payload.products;
      })
      .addCase(getProductsByModel.rejected, (state, action) => {
        state.loading = false;
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch products by model';
      });
  },
});

export const { clearProductDetails, clearError } = productsSlice.actions;
export default productsSlice.reducer;

